// extracted by mini-css-extract-plugin
export default {"products":"Sx-z","card":"Tx-z","oosMessaging":"Ux-z"};